/*  ========================================================================
    # Hooks - Use Breakpoints
    ========================================================================  */

import { useEffect, useState } from 'react';
import tailwindConfig from '../../../tailwind.config';

const useBreakpoints = () => {
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const handleResize = () => setViewportWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [window, handleResize]);

  // Up
  const upMatches = {
    smUp: viewportWidth >= parseInt(tailwindConfig.theme.screens.sm, 10),
    mdUp: viewportWidth >= parseInt(tailwindConfig.theme.screens.md, 10),
    lgUp: viewportWidth >= parseInt(tailwindConfig.theme.screens.lg, 10),
    xlUp: viewportWidth >= parseInt(tailwindConfig.theme.screens.xl, 10),
    xxlUp: viewportWidth >= parseInt(tailwindConfig.theme.screens.xxl, 10)
  };

  // Down
  const downMatches = {
    smDown: viewportWidth < parseInt(tailwindConfig.theme.screens.md, 10),
    mdDown: viewportWidth < parseInt(tailwindConfig.theme.screens.lg, 10),
    lgDown: viewportWidth < parseInt(tailwindConfig.theme.screens.xl, 10),
    xlDown: viewportWidth < parseInt(tailwindConfig.theme.screens.xxl, 10)
  };

  // Exact
  const exactMatches = {
    xs: !upMatches.smUp,
    sm: upMatches.smUp && downMatches.smDown,
    md: upMatches.mdUp && downMatches.mdDown,
    lg: upMatches.lgUp && downMatches.lgDown,
    xl: upMatches.xlUp && downMatches.xlDown,
    xxl: !downMatches.xlDown
  };

  return { ...upMatches, ...downMatches, ...exactMatches, viewportWidth };
};

export default useBreakpoints;
